import { MonetizableEnum } from '@ria-client/segment/enums';
import { MarketplaceProductTypeEnum } from '@ria-client/supergraph/marketplace/constants';
import { ADDITIONAL_MESSAGES } from './constants';
import { EditorialChoice } from './EditorialChoice';

export interface EditorialStandardsProps {
  additionalMessagesType?: MarketplaceProductTypeEnum;
  isRiaOffer?: boolean;
  isFidelityOffer?: boolean;
  monetizable?: MonetizableEnum;
  isReview?: boolean;
}

// Legacy container: bgcolor neutral.lightest (#f7f7f7), padding: 2 (16px).
export function EditorialStandards({
  additionalMessagesType,
  isRiaOffer,
  isFidelityOffer,
  monetizable,
  isReview,
}: EditorialStandardsProps) {
  return (
    <div className="bg-[#f7f7f7] p-2" data-testid="editorial-standards">
      <EditorialChoice
        isFidelityOffer={isFidelityOffer}
        isReview={isReview}
        isRiaOffer={isRiaOffer}
        monetizable={monetizable}
      />
      {additionalMessagesType && (
        <>
          <hr className="my-2 border-0 border-t border-neutral-200" />
          <p className="typography-text-extra-small text-muted-foreground">
            {ADDITIONAL_MESSAGES[additionalMessagesType]}
          </p>
        </>
      )}
    </div>
  );
}
